function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M176.124 123.882C176.124 123.882 214.716 125.741 217.041 139.225C219.365 152.709 171.939 140.62 171.939 140.62L176.124 123.882Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.214 81.1051C115.214 81.1051 121.724 82.9649 126.838 94.124C131.953 105.283 142.182 115.512 142.182 115.512L183.563 123.417L176.589 144.34L137.067 139.225L112.424 125.276L115.214 81.1051Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M115.214 81.1051C115.214 81.1051 121.724 82.9649 126.838 94.124C131.953 105.283 142.182 115.512 142.182 115.512L183.563 123.417L176.589 144.34L137.067 139.225L112.424 125.276L115.214 81.1051Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M380.939 155.266H14.0851V295.22H380.939V155.266Z",
  fill: "#C8BEE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8392 59.7168L58.0239 86.2196L86.8515 87.6145L83.5968 48.5577L53.8392 59.7168Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.3843 236.635L21.9894 295.22H65.6958L72.2052 271.972L77.3198 295.22H122.886C122.886 295.22 123.816 228.265 118.701 227.8C113.587 227.335 23.3843 236.635 23.3843 236.635Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.1385 66.6914C77.0052 66.6914 88.2464 55.4502 88.2464 41.5835C88.2464 27.7168 77.0052 16.4756 63.1385 16.4756C49.2718 16.4756 38.0306 27.7168 38.0306 41.5835C38.0306 55.4502 49.2718 66.6914 63.1385 66.6914Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.827 239.192L33.8459 175.027L16.6424 89.9394L56.2637 75.0719L75.6924 72.7358L85.4596 70.9125L92.431 72.7358C92.431 72.7358 120.329 79.7102 121.724 84.8248C123.118 89.9394 116.144 131.786 116.144 131.786L109.635 166.193L124.048 228.033C124.048 228.033 64.0684 248.491 21.757 239.192H20.827Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M38.2631 113.42V130.623L93.1248 130.698L41.0528 125.044L38.2631 113.42Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M33.5511 160.932L102.428 151.082L33.5511 170.589V160.932Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M142.879 115.745L135.495 142.352L147.994 116.622L142.879 115.745Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.8018 16.4029L88.4189 14.5544C88.4189 14.5544 78.765 3.92602 65.3333 4.85028L69.1111 0.69129C69.1111 0.69129 59.8769 -3.00551 51.4822 6.69864C47.0692 11.7999 41.9634 17.7962 38.7805 24.5509H33.8359L35.8995 29.0949L28.6766 33.6389L36.0902 32.8227C35.6485 35.3111 35.5807 37.8514 35.8891 40.3598C36.2071 42.8689 37.4875 45.1564 39.4601 46.7393C39.4601 46.7393 45.1862 34.887 45.1862 33.0386V37.6596C45.1862 37.6596 49.8033 33.5007 49.8033 30.7281L52.3217 33.9628L53.5809 28.8796L69.1111 33.9628L66.5927 29.8039L76.2466 31.1902L72.4689 26.107C72.4689 26.107 83.382 32.1144 83.8018 37.1976C84.2215 42.2807 87.4158 47.0972 87.4158 47.0972C87.4158 47.0972 95.9741 23.3344 83.8018 16.4029Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.017 109.235H108.472V295.684H287.017V109.235Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.119 150.152H127.071V168.75H259.119V150.152Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.252 199.438H149.771V208.737H236.252V199.438Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.419 215.711H149.938V225.011H236.419V215.711Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.346 231.985H150.105V241.284H193.346V231.985Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.444 278.946H241.451V288.245H261.444V278.946Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.6857 132.716C95.6857 132.716 136.137 126.671 142.182 135.506C148.226 144.34 99.4054 148.989 99.4054 148.989L95.6857 132.716Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.292 89.4744H18.3786C17.1804 89.471 16.0251 89.9206 15.1444 90.7331C12.3789 93.301 6.53121 99.9276 4.08843 111.793C0.833702 127.601 -4.74583 158.289 7.80812 160.613C20.3621 162.938 102.66 151.779 102.66 151.779L96.6156 130.391L37.1007 130.856C37.1007 130.856 38.0306 120.627 36.1707 114.117C34.3109 107.608 21.292 89.4744 21.292 89.4744Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.354 294.706H7.66986V296H387.354V294.706Z",
  fill: "#C8BEE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.139 35.3384H270.307V36.2683H425.139V35.3384Z",
  fill: "#C8BEE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.307 54.8668C280.836 54.8668 289.371 46.3318 289.371 35.8034C289.371 25.2749 280.836 16.7399 270.307 16.7399C259.779 16.7399 251.244 25.2749 251.244 35.8034C251.244 46.3318 259.779 54.8668 270.307 54.8668Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.255 54.8668C367.783 54.8668 376.318 46.3318 376.318 35.8034C376.318 25.2749 367.783 16.7399 357.255 16.7399C346.727 16.7399 338.192 25.2749 338.192 35.8034C338.192 46.3318 346.727 54.8668 357.255 54.8668Z",
  fill: "#C8BEE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.203 55.3317C440.34 55.3317 436.565 54.1863 433.353 52.0405C430.142 49.8947 427.639 46.8448 426.161 43.2765C424.683 39.7081 424.296 35.7816 425.05 31.9935C425.803 28.2054 427.663 24.7257 430.394 21.9946C433.125 19.2636 436.605 17.4036 440.393 16.6501C444.181 15.8966 448.107 16.2834 451.676 17.7614C455.244 19.2395 458.294 21.7425 460.44 24.9539C462.586 28.1653 463.731 31.9409 463.731 35.8033C463.725 40.9807 461.666 45.9445 458.005 49.6055C454.344 53.2665 449.38 55.3258 444.203 55.3317V55.3317ZM444.203 17.2048C440.524 17.2048 436.928 18.2956 433.87 20.3392C430.811 22.3829 428.428 25.2875 427.02 28.686C425.612 32.0844 425.244 35.8239 425.962 39.4317C426.679 43.0394 428.451 46.3533 431.052 48.9544C433.653 51.5554 436.967 53.3267 440.574 54.0444C444.182 54.762 447.922 54.3937 451.32 52.986C454.718 51.5783 457.623 49.1945 459.667 46.136C461.71 43.0775 462.801 39.4817 462.801 35.8033C462.795 30.8724 460.834 26.1451 457.348 22.6584C453.861 19.1717 449.134 17.2104 444.203 17.2048Z",
  fill: "#C8BEE0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 470.677,
  height: 296,
  fill: "white"
})));

function SvgStep1Illustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 296,
    viewBox: "0 0 471 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Illustration);
export default __webpack_public_path__ + "static/media/Step1-illustration.78496145.svg";
export { ForwardRef as ReactComponent };